import { withoutDateKey } from './constants';


export const withoutDateComparator = (a: string, b: string): number => (b === withoutDateKey ? -1 : 0);
